export const JOB_HANDLER_INTERVAL_DEFAULT_MS = 10_000;
export const JOB_HANDLER_INTERVAL_MIN_MS = 1_000;
export const JOB_HANDLER_INTERVAL_MAX_MS = 300_000;